import App from './App.svelte';
import cardBtn from './cardbtn.jpg'
import {getCategoryId} from '../../common/api'
((global) => {
	global['secondary-img-card'] = {
	  bootstrap: (props) => {
		console.log('secondary-img-card props bootstrap', props);
		return Promise.resolve();
	  },
	  mount: (props) => {
		console.log('secondary-img-card props mount', props);
		props.onGlobalStateChange((state, prev) => {
			// state: 变更后的状态; prev 变更前的状态
		});
		var app = new App({
			target: props.container,
			props: {
				list: [],
				cardBtn: cardBtn,
				container: props.container
			}
		});
		app.$on('sliedArrived', (event) => {
			props.setGlobalState({MicroAppShare: {categoryId: event.detail}})
		})
		getCategoryId(props.categoryName).then(list => {
			app.$$set({ list: list })
		})
		return Promise.resolve();
	  },
	  unmount: () => {
		console.log('secondary-img-card purehtml unmount');
		return Promise.resolve();
	  },
	};
  })(window);